/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "S5FyS7tQuUw",
    title:
      "Coke Studio | Season 14 | Phir Milenge | Faisal Kapadia x Young Stunners",
    creator: "Coke Studio",
    views: 6556853,
    uploadedAt: new Date("Mar 22, 2022"),
    categoryName: "Season 14",
    description: `
    Coke Studio 14
    <br/>
    Curated & Produced by Xulfi
    <br/>

    Song Narrative: Adnan Dhool & Xulfi
    <br/>
    Composed by Xulfi
    <br/>
    Written by Adnan Dhool, Talha Anjum, Talha Yunus
    <br/>
    Additional Lyrics by Xulfi
    <br/>
    Music Arranged & Produced by Xulfi & Abdullah Siddiqui
    <br/>
    Mixed by Xulfi
    `,
  },
  {
    _id: "GR5U85eo4yQ",
    title: "Coke Studio | Season 14 | Go | Abdullah Siddiqui x Atif Aslam",
    creator: "Coke Studio",
    views: 8535948,
    uploadedAt: new Date("Mar 18, 2022"),
    categoryName: "Season 14",
    description: `
    Coke Studio 14
    Curated & Produced by Xulfi

    Song Narrative: Abdullah Siddiqui & Maanu
    Composed by Abdullah Siddiqui, Maanu & Atif Aslam
    Written by Abdullah Siddiqui, Maanu & Xulfi
    Music Arranged by Abdullah Siddiqui
    Music Produced by Abdullah Siddiqui & Xulfi
    Mixed by Xulfi & Abdullah Siddiqui
    `,
  },
  {
    _id: "nNZvaMoiATE",
    title:
      "Coke Studio | Season 14 | Thagyan | Zain Zohaib x Quratulain Balouch",
    creator: "Coke Studio",
    views: 7949227,
    uploadedAt: new Date("Mar 13, 2022"),
    categoryName: "Season 14",
    description: `
    Coke Studio 14
    Curated & Produced by Xulfi

    Song Narrative: Zain Zohaib
    Composed by: Zain Zohaib 
    Written by Zohaib Ali
    Music Arranged by Action Zain & Xulfi
    Music Produced by Action Zain & Xulfi
    Mixed by Xulfi
    `,
  },
  {
    _id: "JTJ6q-cGs-o",
    title: "Coke Studio | Season 14 | Beparwah | Momina Mustehsan",
    creator: "Coke Studio",
    views: 9722232,
    uploadedAt: new Date("Mar 7, 2022"),
    categoryName: "Season 14",
    description: `
    Coke Studio 14
    Curated & Produced by Xulfi

    Song Narrative: Adnan Dhool
    Composed by Soch - Adnan Dhool & Rabi Ahmed
    Written by Adnan Dhool, Additional Lyrics by Momina Mustehsan & Xulfi
    Music Arranged by Xulfi & Action Zain
    Music Produced by Xulfi & Action Zain
    Mixed by Xulfi
    `,
  },
  {
    _id: "O3pUsXxCfEk",
    title:
      "Coke Studio | Season 14 | Muaziz Saarif | Faris Shafi x Meesha Shafi",
    creator: "Coke Studio",
    views: 6340501,
    uploadedAt: new Date("Feb 27, 2022"),
    categoryName: "Season 14",
    description: `
    Coke Studio 14
    Curated & Produced by Xulfi

    Song Narrative: Faris Shafi & Meesha Shafi
    Composed by Meesha Shafi, Faris Shafi, & Xulfi
    Written by Faris Shafi & Meesha Shafi
    Music Arranged by Action Zain & Abdullah Siddiqui
    Music Produced by Action Zain, Abdullah Siddiqui & Xulfi
    Mixed by Xulfi
    `,
  },
  {
    _id: "dB0AFSUl2Vk",
    title:
      "Coke Studio | Season 14 | Peechay Hutt | Justin Bibis x Talal Qureshi x Hasan Raheem",
    creator: "Coke Studio",
    views: 10697620,
    uploadedAt: new Date("Feb 19, 2022"),
    categoryName: "Season 14",
    description: `
    Coke Studio 14
    Curated & Produced by Xulfi

    Song Narrative: Hasan Raheem & Xulfi
    Written by Hasan Raheem
    Hook Line by Talal Qureshi
    Composed by Hassan Raheem, Talal Qureshi & Xulfi
    Music Arranged by Talal Qureshi & Xulfi
    Music Produced by Talal Qureshi & Xulfi 

    Mixed by Xulfi
    `,
  },
  {
    _id: "fwJdfyDYhHs",
    title:
      "Coke Studio | Season 14 | Ye Dunya | Karakoram x Talha Anjum x Faris Shafi",
    creator: "Coke Studio",
    views: 6633705,
    uploadedAt: new Date("Feb 12, 2022"),
    categoryName: "Season 14",
    description: `
    Coke Studio 14
    Curated & Produced by Xulfi

    Song Narrative: Adnan Dhool, Xulfi, Talha Anjum & Sherry Khattak
    Composed by Sherry Khattak & Xulfi
    Written by Adnan Dhool, Talha Anjum, Faris Shafi, Xulfi
    Music Arranged & Produced by Xulfi & Sherry Khattak
    Mixed by Xulfi
    `,
  },
  {
    _id: "5Eqb_-j3FDA",
    title: "Coke Studio | Season 14 | Pasoori | Ali Sethi x Shae Gill",
    creator: "Coke Studio",
    views: 70443390,
    uploadedAt: new Date("Feb 7, 2022"),
    categoryName: "Season 14",
    description: `
    Coke Studio 14
    Curated & Produced by Xulfi

    Song Narrative: Ali Sethi
    Written by Ali Sethi & Fazal Abbas

    Composed by Ali Sethi & Xulfi
    Music Arranged by Abdullah Siddiqui & Sherry Khattak
    Music Produced by Abdullah Siddiqui & Xulfi

    Mixed by Xulfi
    `,
  },
  {
    _id: "diGJy8eFbWw",
    title:
      "Coke Studio | Season 14 | Neray Neray Vas | Soch The Band x Butt Brothers",
    creator: "Coke Studio",
    views: 9605031,
    uploadedAt: new Date("Feb 1, 2022"),
    categoryName: "Season 14",
    description: `
    Coke Studio 14
    Curated & Produced by Xulfi

    Song Narrative: Adnan Dhool
    Composed by Soch (Adnan Dhool & Rabi Ahmed) & Butt Brothers (Shamroz Butt & Umair Butt)
    Written by Adnan Dhool & Butt Brothers (Shamroz Butt & Umair Butt)
    Music Arranged & Produced by Action Zain and Xulfi
    Mixed by Xulfi
    `,
  },
  {
    _id: "BUm_hFMlsgg",
    title: "Coke Studio | Season 14 | Mehram | Asfar Hussain x Arooj Aftab",
    creator: "Coke Studio",
    views: 9504975,
    uploadedAt: new Date("Jan 28, 2022"),
    categoryName: "Season 14",
    description: `
    Coke Studio 14
    Curated & Produced by Xulfi

    Song Narrative: Asfar Hussain and Xulfi 
    Composed by Asfar Hussain & Xulfi
    Written by Asfar Hussain, Additional Lyrics by Xulfi 
    Music Arranged & Produced by Abdullah Siddiqui, Xulfi & Arooj Aftab
    Mixed by Xulfi
    `,
  },
  {
    _id: "HrFlFMK1mKI",
    title:
      "Coke Studio | Season 14 | Sajan Das Na | Atif Aslam x Momina Mustehsan",
    creator: "Coke Studio",
    views: 11370537,
    uploadedAt: new Date("Jan 23, 2022"),
    categoryName: "Season 14",
    description: `
    Coke Studio 14
    Curated & Produced by: Xulfi

    Song Narrative: Adnan Dhool, Xulfi & Momina Mustehsan
    Written by: Adnan Dhool, Additional Lyrics by: Momina Mustehsan
    Composed by: Abdullah Siddiqui, Adnan Dhool, Momina Mustehsan & Xulfi 
    Music Arranged & Produced by: Abdullah Siddiqui & Xulfi 
    Mixed by: Xulfi
    Mastered by: Chris Athens
    `,
  },
  {
    _id: "zQDAi8tI-cU",
    title:
      "Coke Studio | Season 14 | Kana Yaari | Kaifi Khalil x Eva B x Abdul Wahab Bugti",
    creator: "Coke Studio",
    views: 16103943,
    uploadedAt: new Date("Jan 19, 2022"),
    categoryName: "Season 14",
    description: `
    Coke Studio 14
    Curated & Produced by Xulfi

    Song Narrative: Kaifi Khalil
    Composed by Kaifi Khalil
    Written by Kaifi Khalil, Eva B, Wahab Bugti
    Music Arranged & Produced by Abdullah Siddiqui, Xulfi, Arsalan Hasan, Sherry Khattak
    Mixed by Xulfi
    `,
  },
  {
    _id: "7D4vNcK6D38",
    title: "Coke Studio | Season 14 | Tu Jhoom | Naseebo Lal x Abida Parveen",
    creator: "Coke Studio",
    views: 31881382,
    uploadedAt: new Date("Jan 14, 2022"),
    categoryName: "Season 14",
    description: `
    Coke Studio 14
    Curated & Produced by Xulfi
    
    Song Narrative: Xulfi
    Written by Adnan Dhool
    Urdu Kalam(Abida Parveen) : Hasrat Mohani

    Composed by Xulfi
    Music Arranged & Produced by Xulfi & Abdullah Siddiqui
    Mixed by Xulfi
    `,
  },
  {
    _id: "OCCXUwKMH4s",
    title: "Coke Studio Season 12 | Daachi Waaliya | Hadiqa Kiani",
    creator: "Coke Studio",
    views: 3405993,
    uploadedAt: new Date("Dec 23, 2019"),
    categoryName: "Season 12",
    description: `
    #CokeStudio12 presents Daachi Waaliya, a song that carries with it flavors of rural Punjab and the rhythm of a camel's gait. Blending the song with Sufi verses written by Bulleh Shah and Waris Shah, Hadiqa Kiani turns this classic, folk tune into a contemplative piece on the nature of love

    Produced by: Rohail Hyatt
    Coke Studio Season 12, Episode 5
    `,
  },
  {
    _id: "NDkCEFmYfE4",
    title: "Coke Studio Season 12 | Aaye Kuch Abr | Atif Aslam",
    creator: "Coke Studio",
    views: 7056924,
    uploadedAt: new Date("Nov 29, 2019"),
    categoryName: "Season 12",
    description: `
    #CokeStudio12 presents an incarnation of Faiz Ahmed Faiz’s poetry in the voice of Atif Aslam with Aaye Kuch Abr. Speaking of solitude and finding personal solace in life’s little pleasures, the ghazal provides a space for one to find the common humanity in one's own experiences.  

    Produced by: Rohail Hyatt
    Original Artist: Mehdi Hassan
    Poetry by: Faiz Ahmed Faiz
    Composed by: Mehdi Hassan
    Copyright in the original works for the original song owned or otherwise controlled by -“EMI (Pakistan) Ltd”
    Coke Studio Season 12, Episode 6
    `,
  },
  {
    _id: "Ky34KrtRgNc",
    title: "Coke Studio Season 12 | Heeray | Rahat Fateh Ali Khan & Aima Baig",
    creator: "Coke Studio",
    views: 3148405,
    uploadedAt: new Date("Nov 25, 2019"),
    categoryName: "Season 12",
    description: `
    #CokeStudio12 presents a modern retelling of the tale of Heer-Ranjha, brought to life in the voice of Ustad Rahat Fateh Ali Khan and Aima Baig. In a musical style that is new to his repertoire, Khan Sahab modernises this centuries-old saga, bringing it to the Heers and Ranjhas of today. 

    Produced by: Rohail Hyatt
    Coke Studio Season12, Episode 5
    `,
  },
  {
    _id: "QqI5pMJuFbE",
    title: "Coke Studio Season 12 | Hairaan Hua | Sanam Marvi",
    creator: "Coke Studio",
    views: 7465432,
    uploadedAt: new Date("Nov 15, 2019"),
    categoryName: "Season 12",
    description: `
    With poetry composed by Sachal Sarmast, Sanam Marvi graces #CokeStudio12 in Hairaan Hua, a celebration of the Ultimate Beauty of the Divine, and the love and wonder it inspires in His devotees. 

    Produced: by Rohail Hyatt
    Original lyricist: Sachal Sarmast
    Original composer: Abida Parveen 

    Coke Studio Season 12 Episode 4
    `,
  },
  {
    _id: "gKLM8GpxQ4k",
    title: "Coke Studio Season 12 | Dhola | Sahir Ali Bagga & Aima Baig",
    creator: "Coke Studio",
    views: 16722474,
    uploadedAt: new Date("Nov 15, 2019"),
    categoryName: "Season 12",
    description: `
    Returning to #CokeStudio12 in Dhola, Sahir Ali Bagga and Aima Baig celebrate the joy and vulnerability of being in love in a conversation between two companions who have vowed to be give each other their hearts. 

    Produced: by Rohail Hyatt
    Coke Studio Season 12, Episode 4
    `,
  },
  {
    _id: "hR8FEdC6aAs",
    title: "Coke Studio Season 12 | Gulon Main Rang | Ali Sethi",
    creator: "Coke Studio",
    views: 6026493,
    uploadedAt: new Date("Nov 15, 2019"),
    categoryName: "Season 12",
    description: `
    Ali Sethi takes the stage on #CokeStudio12 in Gulon Main Rang, a ghazal by Faiz Ahmed Faiz that weaves multiple layers of meanings within images of blossoming springtime and romantic yearning. 

    Produced by: Rohail Hyatt
    Original Artist: Mehdi Hassan
    Poetry by: Faiz Ahmed Faiz
    Composed by: Salim Shahid / Mehdi Hassan
    Copyright in the original works for the original song owned or otherwise controlled by -“EMI (Pakistan) Ltd”
    Coke Studio Season 12, Episode 4
    `,
  },
  {
    _id: "ect_mqKkXTc",
    title:
      "Coke Studio Season 12 | Mubarik Mubarik | Atif Aslam & Banur's Band",
    creator: "Coke Studio",
    views: 7873371,
    uploadedAt: new Date("Nov 8, 2019"),
    categoryName: "Season 12",
    description: `
    Journeying to #CokeStudio12 from Balochistan, Banur's Band collaborates with Atif Aslam in Mubarik Mubarik, a festive number showcasing melodies and rhythms that have traveled down to the Baloch people through history and tradition.

    Produced by: Rohail Hyatt
    Coke Studio Season12, Episode 3
    `,
  },
  {
    _id: "F0Mfz3B16KE",
    title: "Coke Studio Season 12 | Saiyaan | Shuja Haider & Rachel Viccaji",
    creator: "Coke Studio",
    views: 8697703,
    uploadedAt: new Date("Oct 28, 2019"),
    categoryName: "Season 12",
    description: `
    #CokeStudio12 presents Saiyaan, a duet by Shuja Haider & Rachel Viccaji that hints at the ever present feeling of selfless love, a kind so rare and oft found in folktales that have traveled down to us through time.

    Produced by: Rohail Hyatt
    Original Artist: Noor Jehan
    Lyrics by: Tanvir Naqvi
    Composed by: Bakshi Wazir
    Copyright in the original musical composition and lyrics for the Original Songs owned or otherwise controlled by– “EMI (Pakistan) Ltd"
    `,
  },
  {
    _id: "e6o8GhoofzE",
    title: "Coke Studio Season 12 | Dam Mastam | Rahat Fateh Ali Khan",
    creator: "Coke Studio",
    views: 7547917,
    uploadedAt: new Date("Oct 18, 2019"),
    categoryName: "Season 12",
    description: `
    #CokeStudio12 presents Dam Mastam; composed in raag Bhimpalasi, the song uses the metaphor of being mast, a state of forgetting one's self in love of the Divine.

    Produced by: Rohail Hyatt
    `,
  },
  {
    _id: "74cVT_tUpck",
    title: "Coke Studio Season 12 | Wohi Khuda Hai | Atif Aslam",
    creator: "Coke Studio",
    views: 52270951,
    uploadedAt: new Date("Oct 11, 2019"),
    categoryName: "Season 12",
    description: `
    Song Name: Wohi Khuda Hai
    #WohiKhudaHai, a praise of God as the One Creator of a system that runs in balance and harmony, recited in the voice of Atif Aslam. 
    #CokeStudio12

    Produced By: Rohail Hyatt
    `,
  },
  // {
  //   _id: "klEYnZjf66s",
  //   title:
  //     "Coke Studio Season 11| Luddi Hai Jamalo| Ali Sethi & Humaira Arshad",
  //   creator: "Coke Studio",
  //   views: 9975242,
  //   uploadedAt: new Date("Oct 12, 2018"),
  //   categoryName: "Season 11",
  //   description: `
  //   Coke Studio Season 11| Episode 8
  //   #LuddiHaiJamalo is a unique blend combining the richness of Punjabi folk and top mehndi songs with a twist of disco, performed by Ali Sethi and Humaira Arshad! Ali Sethi has sung a few Coke Studio songs like Ranjish hi Sahi, Tinak Dhin, Aaqa and now Luddi Hai Jamalo. Accompanied by the beautiful voice of Humaira Arshad, Ali Sethi sings this wedding song that will make it to the top shadi songs and top desi songs of 2018! #CokeStudio11
  //   `,
  // },
  // {
  //   _id: "gK-eU6QFEnM",
  //   title: "Coke Studio Season 11| Ballay Ballay| Abrar Ul Haq and Aima Baig",
  //   creator: "Coke Studio",
  //   views: 14982215,
  //   uploadedAt: new Date("Oct 5, 2018"),
  //   categoryName: "Season 11",
  //   description: `
  //   Coke Studio Season 11| Episode 7
  //   #BallayBallay is a Punjabi mash-up of the desi wedding songs by Abrar Ul Haq and Aima Baig. The track has been masterfully created by the house band featuring a strong groove improvised around mehndi songs for dancing and Pakistani shaadi songs.
  //   Just like his many hits, this will make it to the list of Abrar Ul Haq’s top songs and top mehndi songs for dancing performed on the Coke Studio Season 11 stage. #CokeStudio11
  //   `,
  // },
  {
    _id: "w3s8cjG2WYY",
    title: "Coke Studio Season 11 | Hawa Hawa | Gul Panrra & Hassan Jahangir",
    creator: "Coke Studio",
    views: 28024525,
    uploadedAt: new Date("Sep 28, 2018"),
    categoryName: "Season 11",
    description: `
    Coke Studio Season 11 | Episode 6
    Song Name: Hawa Hawa
    A star from 80’s Pakistani music and an age-old folk tune turned Pakistani pop chart-topper, #HawaHawa gets revived with Hassan Jahangir’s classic rock star vibes and Gul Panrra's sweet voice! With percussion-driven Balochi Lewa beats this nostalgic remix will become a favorite in the desi dance songs of 2018 and definitely be one of the top trending songs of Coke studio 11. #CokeStudio11
    `,
  },
  // {
  //   _id: "WzlO79d3S8c",
  //   title:
  //     "Coke Studio Season 11 | Piya Ghar Aaya | Fareed Ayaz | Abu Muhammad Qawwal and Brothers",
  //   creator: "Coke Studio",
  //   views: 17810455,
  //   uploadedAt: new Date("Aug 24, 2018"),
  //   categoryName: "Season 11",
  //   description: `
  //   Coke Studio Season 11 | Episode 3
  //   Experience the emotions of the wildly popular classic, #PiyaGharAaya, as Fareed Ayaz explains the divine notion of this Sufi kalaam accompanied with the powerful vocals of Abu Muhammad Qawwal and Brothers. #CokeStudio11
  //   `,
  // },
  // {
  //   _id: "S33PzzeozpU",
  //   title:
  //     "Coke Studio Season 11 | Roye Roye | Sahir Ali Bagga and Momina Mustehsan",
  //   creator: "Coke Studio",
  //   views: 17635769,
  //   uploadedAt: new Date("Aug 24, 2018"),
  //   categoryName: "Season 11",
  //   description: `
  //   Coke Studio Season 11 | Episode 3
  //   Song Name: Roye Roye
  //   #RoyeRoye is a ballad composed by Sahir Ali Bagga along with Momina Mustehsan’s emotive vocals as an ode to undying love. #CokeStudio11

  //   Infectious, fervent, and lyrical, ‘Roye Roye’ rides on the emotional landscape of love and loneliness. Sahir Ali Bagga music is the natural descendant of love ballad that swings between the space of dramatic yet empathetic. Along side Momina Mustehsan’s riveting vocals, the song conveys the ache of unrequited love.

  //   It’s a masterclass in atmospheric delivery that evolves with traditional sound of duduk and bansuri, the ethnic sound of matka and a sentimental string section. Roye Roye instantly builds an authentic musical palette that one can resonate with.
  //   `,
  // },
  // {
  //   _id: "LrCek73_e_M",
  //   title:
  //     "Coke Studio Season 11 | Shikwa/Jawab-e-Shikwa | Natasha Baig, Fareed Ayaz & Abu Muhammad Qawwal",
  //   creator: "Coke Studio",
  //   views: 20761794,
  //   uploadedAt: new Date("Aug 10, 2018"),
  //   categoryName: "Season 11",
  //   description: `
  //   Coke Studio Season 11 | Episode 1
  //   Song Name: Shikwa/Jawab-e-Shikwa
  //   The hard-hitting emotions of #ShikwaJawabEShikwa come to life as Fareed Ayaz, Abu Muhammad Qawwal & Brothers are joined by Natasha Baig in this new intense melody. Their unique rendition explores the genre of rock and the signature sound of qawwali in this one of a kind track. #CokeStudio11
  //   `,
  // },
  {
    _id: "HpfrSzRgWhs",
    title:
      "Coke Studio Season 10 | Us Rah Par | Ali Hamza & Ali Zafar feat. Strings",
    creator: "Coke Studio",
    views: 7343689,
    uploadedAt: new Date("Sep 21, 2017"),
    categoryName: "Season 10",
    description: `
    Coke Studio Season 10 | Season Finale
    Produced & Directed by Strings
    Music Directed by Jaffer Zaidi
    Originally Composed by Shoaib Mansoor
    Lyrics by Shoaib Mansoor

    The loss of Junaid Jamshed sent reverberations across the world. Drawing inspiration from Jamshed’s signature sound, Jaffer Zaidi creates a heartfelt tribute for the gentleman who will forever remain the icon for contemporary Pakistani pop music. Ali Zafar & Ali Hamza come together to celebrate and commemorate the life and legacy of a man who helped millions of people find their own way in this fitting tribute.
    `,
  },
  {
    _id: "p3D-oqGdW9o",
    title: "Coke Studio Season 10 | Maula Tera Noor | Shafqat Amanat Ali Khan",
    creator: "Coke Studio",
    views: 5562010,
    uploadedAt: new Date("Sep 21, 2017"),
    categoryName: "Season 10",
    description: `
    Coke Studio Season 10 | Season Finale
    Produced & Directed by Strings
    Music Directed by Shani Arshad
    Composed by Shani Arshad
    Lyrics by Sabir Zafar

    A silvery hamd sung beautifully by Shafqat Amanat Ali Khan is a spiritual journey of finding the light to guide and protect the soul. A bright and airy composition, Maula Tera Noor has a purposefully simple melody to steer the listeners towards the richness and potency of the words. An enchanting flute lifts the song into a dimension of purity and simplicity as the banjo gives a soft punch of color into this soul-stirring hamd.
    `,
  },
  {
    _id: "PePGHi6IeZQ",
    title: "Coke Studio Season 10 | Baanware | Shuja Haider & Aima Baig",
    creator: "Coke Studio",
    views: 8464763,
    uploadedAt: new Date("Sep 21, 2017"),
    categoryName: "Season 10",
    description: `
    Coke Studio Season 10 | Season Finale
    Produced & Directed by Strings
    Music Directed by Shuja Haider
    Composed by Shuja Haider
    Lyrics by Shuja Haider 
    ‘Bhooli Bisri’ licensed by EMI Pakistan
    ‘Bhooli Bisri’
    
    Originally sung by Mehdi Hasan
    Lyrics by Syed Raza Tirmazi
    
    Love permeates through this song as Shuja Haider creates yet another score for those struck by the puzzling predicament of romance. Aima Baig shines through as her powerful, ethereal vocals intertwine themselves in the soft melody of the song. The duet shaped as a musical conversation brings forth the nuances and intricacies of heartbreak in a delightfully poignant manner.
    `,
  },
  {
    _id: "DngeAcpK6LI",
    title: "Coke Studio Season 10 | Ghoom Taana | Momina Mustehsan & Irteassh",
    creator: "Coke Studio",
    views: 3142604,
    uploadedAt: new Date("Sep 15, 2017"),
    categoryName: "Season 10",
    description: `
    Coke Studio Season 10 | Episode 6
    Produced & Directed by Strings
    Music Directed by Salman Ahmad
    Composed by Salman Ahmad
    Lyrics by Sabir Zafar & Salman Ahmad
    #CokeStudio10
    
    With the force of 7 female voices singing, this rendition of Ghoom Taana is emotionally-stirring piece that siphons the musical energies of Salman Ahmad in it’s truest form. Laced with his signature guitar tones and musicality, the song is an appeal to light in the time of darkness. Momina Mustehsan’s sweet, crystalline tone paired with the incredible chorus of the young girls from Irteassh create an anthem for the ages. 
    `,
  },
  {
    _id: "a2IK6XfdYss",
    title:
      "Coke Studio Season 10 | Kaatay Na Katay | Aima Baig, Humera Arshad & Rachel Viccaji",
    creator: "Coke Studio",
    views: 4954196,
    uploadedAt: new Date("Sep 15, 2017"),
    categoryName: "Season 10",
    description: `
    Coke Studio Season 10 | Episode 6
    Produced & Directed by Strings
    Music Directed by Ali Hamza
    Originally Composed by Nisar Bazmi
    Lyrics by Saifuddin Saif & Ali Hamza
    #CokeStudio10
    Licensed by EMI Pakistan

    Rock meets semi-classical in this exhilarating audio-visual experience as this trio of powerhouses take the stage. Bursting at the seams with energy, Kaatay Na Katay features Humera Arshad, Rachel Viccaji & Aima Baig. With this stellar trifecta of vocal innovation, Ali Hamza sculpts an innovative blend of instrumentation and musical styles. Aima Baig brings her youthful spunk to the forefront teaming up with Rachel Viccaji’s cool, raspy vocals to bring the drive and powerful rock element. Juxtaposed with this intensity, Humera Arshad creates space of her own with her signature semi-classical vocals steering the song into a truly traditional realm. Complete with a mandolin solo, big drums and a vibrant energy, Ali Hamza masterfully creates a larger than life rendition with a collection of some of the most versatile voices in the industry today. 
    `,
  },
  {
    _id: "Gar-Vw9UzVs",
    title:
      "Coke Studio Season 10 | Dam Mast Qalandar | Umair Jaswal & Jabar Abbas",
    creator: "Coke Studio",
    views: 4036346,
    uploadedAt: new Date("Sep 15, 2017"),
    categoryName: "Season 10",
    description: `
    Coke Studio Season 10 | Episode 6
    Produced & Directed by Strings
    Music Directed by Shuja Haider
    Originally Composed by Farrukh Fateh Ali
    Lyrics by Bari Nizami
    #CokeStudio10
    Licensed by EMI Pakistan
    
    What is a dhamaal without a solid groove? Shuja Haider paints this evergreen kalaam with fresh, vibrant colors through a tight percussive section and warm, grooving bass. Jabar Abbas’s pristine timbre and lush modulations woven with Umair Jaswal’s textured vocal stylings makes for the perfect ingredients for this emotional, high-energy rendition. The goonj of the percussions finds itself resonating with the urgent pounding of the heart as an anthemic chorus of humnawa and backing vocalists color the soundscape with the drive of the kalaam. With a playful pocket and an intricately designed arrangement, the rendition serves to elevate its listeners to another realm. 
    `,
  },
  {
    _id: "TzdMLhGOIhA",
    title:
      "Coke Studio Season 10 | Sab Maya Hai | Attaullah Esakhelvi & Sanwal Esakhelvi",
    creator: "Coke Studio",
    views: 22565919,
    uploadedAt: new Date("Sep 8, 2017"),
    categoryName: "Season 10",
    description: `
    Coke Studio Season 10 | Episode 5
    Song Name: Sab Maya Hai
    Produced & Directed by Strings
    Music Directed by Shuja Haider
    Lyrics by Ibn-e-Insha, Shakir Shuja Abadi, Mazhar niazi, Farooq Rokhri & Shuja Haider
    Originally composed by Attaullah Esakhelvi
    
    Bringing the sounds of the soil to Season 10, Attaullah Esakhelvi & Sanwal Esakhelvi narrate a sordid tale of the depravity that is found within the realms of the material world. Attaullah Esakhelvi’s unique yet familiar folk tone is brutally apt in depicting the pain of coming to terms with the illusions that surround us. Shuja Haider creates a unique soundscape by pairing this with the soft yet electric energy of Sanwal Esakhelvi’s tone. Upon a backdrop of groovy and emotive backing vocals, accented with the banjo and flute, this song is a journey towards uncovering the truth. 
    `,
  },
  {
    _id: "SCOKysMnH50",
    title:
      "Coke Studio Season 10 | Latthay Di Chaadar | Quratulain Balouch & Farhan Saeed",
    creator: "Coke Studio",
    views: 32856848,
    uploadedAt: new Date("Sep 1, 2017"),
    categoryName: "Season 10",
    description: `
    Coke Studio Season 10 | Episode 4
    Song Name: Latthay Di Chaadar
    Produced & Directed by Strings
    Music Directed by Shani Arshad
    Latthay Di Chaadar, originally composed by Khalil Ahmed & lyrics by Bashir Manzar
    Dekh Tera, originally composed by Niaz Ahmed & lyrics by Muhammad Nasir
    ‘Latthay Di Chaadar’ & ‘Dekh Tera’ licensed by EMI Pakistan
    
    Colors seem more vivid in this song as a traditional South Asian wedding song blends with an 80s pop track in Shani Arshad’s latest concoction. An upbeat track nuanced with the rhythm of dandiyaan and a gliding flute, the song is further embellished by the fact that it is a duet. Farhan Saeed’s warm, tuneful take on ‘Dekh Tera’ paired with Quratulain Balouch’s textured, radiant voice belting out Latthay Di Chaadar makes for the perfect mixture. With a strong backing vocals section, the song finds itself exploring the musical spectrum of our vibrant traditional past.
    `,
  },
  {
    _id: "XLPv-_MBFC8",
    title:
      "Coke Studio Season 10 | Mujh Se Pehli Si Muhabbat | Humera Channa & Nabeel Shaukat",
    creator: "Coke Studio",
    views: 7458559,
    uploadedAt: new Date("Aug 25, 2017"),
    categoryName: "Season 10",
    description: `
    Coke Studio Season 10 | Episode 3
    Produced & Directed by Strings
    Music Directed by Mekaal Hasan
    Originally composed by Rashid Attre
    Lyrics by Faiz Ahmed Faiz
    Licensed by EMI Pakistan
    
    Bringing an avant-garde aesthetic to the Coke Studio landscape, Mekaal Hasan’s debut as a music director finds him taking a classic ghazal and framing it with progressive and experimental tropes. Unleashing his signature sound, courtesy of a lush guitar tone and Ahsan Pappu’s emotive flute-playing, Hasan creates a carefully constructed soundscape fitting for the themes of rapture and cruelty that Faiz touches upon in his poetry. The silvery vocals of Humera Channa paired with the honeyed tone of Nabeel Shaukat’s voice make for a fantastic combination to take on this humble tribute to Malika-e-Tarranum, Noor Jehan.
    `,
  },
  {
    _id: "eoz9gr9QYes",
    title:
      "Coke Studio Season 10 | Laal Meri Pat | Quratulain Balouch ft. Akbar Ali & Arieb Azhar",
    creator: "Coke Studio",
    views: 8431649,
    uploadedAt: new Date("Aug 25, 2017"),
    categoryName: "Season 10",
    description: `
    Coke Studio Season 10 | Episode 3
    Produced & Directed by Strings
    Music Directed by Strings
    
    Entrancing, enthralling and ethereal, Strings’ rendition takes Laal Meri Pat past the threshold of a zealous dhamaal and places it into an ambient and spiritually opulent sonic environment. Arieb Azhar’s baritone spoken word juxtaposed with Akbar Ali’s haunting alaaps steer the song into a beautiful auditory vista as Quratulain Balouch’s unrestrained and captivating persona in the song adds to the trance of the reverie with each emphatic zephyr of dama-dam.  A multi-faceted and nuanced blend of devotional poetry, fervent chants of ‘Jhulelal’ perched upon a dreamy, psychedelic soundscape of the sitar and a traditional groove, the rendition is rich with emotion and mysticism. 
    #CokeStudio10
    `,
  },
  {
    _id: "pba_YmWDAIU",
    title: "Coke Studio Season 10 | Ranjish Hi Sahi | Ali Sethi",
    creator: "Coke Studio",
    views: 20917301,
    uploadedAt: new Date("Aug 11, 2017"),
    categoryName: "Season 10",
    description: `
    Coke Studio Season 10 | Episode 1
    Produced & Directed by Strings
    Music Directed by Jaffer Zaidi
    Originally Composed by Nisar Bazmi
    Lyrics by Ahmed Faraz
    Additional Lyrics by Talib Baghpati
    Licensed by EMI Pakistan
    `,
  },
  {
    _id: "cs9ORHI8o38",
    title: "Coke Studio Season 10 | Muntazir | Danyal Zafar & Momina Mustehsan",
    creator: "Coke Studio",
    views: 18338124,
    uploadedAt: new Date("Aug 11, 2017"),
    categoryName: "Season 10",
    description: `
    Coke Studio Season 10 | Episode 1
    Song Name: Muntazir
    Produced & Directed by Strings
    Music Directed by Strings
    Lyrics by Strings
    `,
  },
  {
    _id: "ZQMn5wIoAno",
    title:
      "Coke Studio Season 9 | Tu Kuja Man Kuja | Shiraz Uppal & Rafaqat Ali Khan",
    creator: "Coke Studio",
    views: 167184965,
    uploadedAt: new Date("Sep 23, 2016"),
    categoryName: "Season 9",
    description: `
    Coke Studio Season 9 | Season Finale
    Song Name: Tu Kuja Man Kuja
    Original Composition by Nusrat Fateh Ali Khan
    Lyrics by Muzaffar Warsi 
    Produced by Strings
    
    ‘Tu Kuja Man Kuja’ is a mesmerizing qawwali built upon a cyclic music structure that draws you in from start to finish within the space of its meticulously selected soundscapes. Rafaqat Ali Khan’s effortless and pitch perfect vocals brings the track into a spiritual and cosmic realm exhibiting words penned by Muzaffar Warsi, and originally composed by the maestro – Nusrat Fateh Ali Khan. Shiraz Uppal’s soulful voice serves as the perfect accompaniment to the pulsing bass, and the inclusion of the dynamic tabla to maximize the essence of the traditional qawwali genre. #CokeStudio9
    `,
  },
  {
    _id: "Uks8psEpmB4",
    title: "Coke Studio Season 9 | Rang | Rahat Fateh Ali Khan & Amjad Sabri",
    creator: "Coke Studio",
    views: 42383205,
    uploadedAt: new Date("Sep 23, 2016"),
    categoryName: "Season 9",
    description: `
    Coke Studio Season 9 | Season Finale
    Song Name: Rang
    Kalaam of Ameer Khusro
    Music Directed by Shani Arshad
    Produced by Strings
    In all its melodramatic glory, and approximately 40 years ago, a shrine echoed with the sound of a traditional qawwali performed in an epic collaboration by the maestros, Ghulam Farid Sabri with Nusrat Fateh Ali Khan. The divine kalaam of Amir Khusro – ‘Rang’ – soared through the skies. In what has been deemed as the most anticipated performance of Coke Studio’s Season 9, the two families return to the platform for the first time since, as Rahat Fateh Ali Khan and Amjad Sabri collaborate to perform the very track, four decades later.
    
    Recorded in the first and only take, as the song’s melodic heart unfolds Rahat’s vocals float over the top, forging ahead into well-known territories. With the rasp of Sabri’s rumbling vocals fuelled by a momentary key change, combining the sounds of the past and the present whilst igniting the sense of nostalgia most gracefully – carrying you off to somewhere else entirely. Embodying the classic traditional essence, the kalaam comes alive enriched by the raw, soulful inflections warming your heart and soul for many more decades. #CokeStudio9
    `,
  },
  {
    _id: "8367ETnagHo",
    title:
      "Coke Studio Season 9 | Tera Woh Pyar | Momina Mustehsan & Asim Azhar",
    creator: "Coke Studio",
    views: 155464388,
    uploadedAt: new Date("Sep 16, 2016"),
    categoryName: "Season 9",
    description: `
    Coke Studio Season 9 | Episode 6
    Song Name: Tera Woh Pyar
    Music Directed by Shuja Haider 
    Composed by Shuja Haider
    Lyricis by Naqash Hyder
    Produced by Strings
    
    Sublime, beautiful, and soul stirring are all words best to describe ‘Tera Woh Pyaar’ and ‘Nawazishein’ performed by Momina Mustehsan with Asim Azhar. The romantic ballads, both originally sung by Shuja Haider, features him as the music director, calling the shots in a track that truly delivers from the heart. The soft piano and the subtle sound of the sitar create a fitting atmosphere for Momina’s soft vocals, sung with utmost grace, as Asim croons over cinematic violins about the love story, packed full of emotions. Midway through the duration, as the track gathers momentum, it brings together elements of the Pakistani pop scene of the bygone era, and takes you to a dreamy place whilst celebrating romance and leaving one smitten. #CokeStudio9
    `,
  },
  {
    _id: "kw4tT7SCmaY",
    title:
      "Coke Studio Season 9 | Afreen Afreen | Rahat Fateh Ali Khan & Momina Mustehsan",
    creator: "Coke Studio",
    views: 350633419,
    uploadedAt: new Date("Aug 19, 2016"),
    categoryName: "Season 9",
    description: `
    Coke Studio Season 9 | Episode 2
    Song Name: Afreen Afreen
    Nusrat Fateh Ali Khan was one of the shining lights of Pakistan, a Qawwali Shahehshah whose talent was heralded both locally and globally. To celebrate the legend that still lives 19 years on, Coke Studio presents
    Afreen Afreen, Rahat Fateh Ali Khan & Momina Mustehsan, Episode 2, Coke Studio 9
    
    Music Directed by Faakhir Mehmood
    Produced by Strings
    The beautifully crafted ‘Afreen Afreen’ sung two decades ago by the legendry, Nusrat Fateh Ali Khan still holds the strength to serenade the audience with its poetic and soothing sensibilities. The reformation of the track on Coke Studio – arranged by Faakhir Mehmood and performed by maestro Rahat Fateh Ali Khan and debutant, Momina Mustehsan – transforms the Qawwali seamlessly into an unplugged track. Within the genre, the atmosphere of the song remains ambient and acoustic, as the bare minimum elements give room to Rahat’s majestic vocals to improvise the mastery he possesses. Momina enters the song as she punctuates the additional melody with her laid-back effortless velvety vocals. Towards the end, the track is perfectly complimented with the incredible drum roll and a hyper groove as the traditional ‘Afreen Afreen’ chants are delivered with heartfelt emotion and melodic panache.
    #CokeStudio9
    `,
  },
];
